"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legals = void 0;
const React = require("react");
const styles = require("./styles.scss");
const react_free_scrollbar_1 = require("react-free-scrollbar");
const Legals = ({ lead, sections }) => (React.createElement("div", { className: styles.acceptLegals_container },
    React.createElement(react_free_scrollbar_1.default, null,
        React.createElement("div", { dangerouslySetInnerHTML: { __html: lead }, className: styles.acceptLegals_content }),
        sections.map((section, index) => (React.createElement("div", { key: index, className: styles.acceptLegals_content },
            React.createElement("h4", { className: styles.acceptLegals_content_heading }, section.heading),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: section.body } })))))));
exports.Legals = Legals;
exports.default = exports.Legals; // TODO: remove me, left for legacy components still using default imports
//# sourceMappingURL=index.js.map